import React from 'react';
import { RobbieMark } from '../ui';

/**
 * The login hero, rebuilt for a phone rather than deleted on one.
 *
 * The desktop login is a split screen: navy on the left with Robbie waving and
 * the promise, canvas on the right with the form. A phone has one column, so
 * the two stop being side by side and become one above the other — the navy
 * runs the whole screen and the form card floats on it. Nothing is dropped:
 * the mark, the wave, the headline and the glows all arrive, sized for the
 * screen they are on.
 *
 * The copy is shorter than the desktop's on purpose. Three lines of promise
 * above the fold pushes the email field below it, and the field is what the
 * person came for — most of them arriving from an invitation email on the
 * phone they read it on.
 *
 * There is deliberately no lockup above the wave. The desktop panel carries
 * one, but it sits a screen-height away from the waving mark and reads as
 * navigation; stacked twenty pixels apart on a phone the same two marks read
 * as the page saying its own name twice. The wave is the brand here, and the
 * name is in the footer under the card (owner, 18 Sep 2026).
 */
export const LoginPhoneIntro: React.FC = () => (
  <div className="relative flex flex-col items-center px-s5 pb-s7 pt-[44px] text-center md:hidden">
    {/* The same two glows the desktop hero carries, pulled to the corners of a
        375px screen instead of a half-page panel. */}
    <span aria-hidden className="pointer-events-none absolute -right-[120px] -top-[140px] h-[300px] w-[300px] rounded-round bg-navy-glow-blue" />
    <span aria-hidden className="pointer-events-none absolute -left-[120px] top-[30px] h-[280px] w-[280px] rounded-round bg-navy-glow-violet" />

    <span className="relative block">
      <RobbieMark size="xl" state="waving" glow aria-label="Hello Robbie" />
    </span>

    <h1 className="relative m-0 mt-s6 text-[25px] font-bold leading-[1.22] tracking-[-0.015em] text-white">
      Smarter sourcing,
      <br />
      start to finish.
    </h1>
    <p className="relative m-0 mt-s4 max-w-[300px] text-body-md leading-[1.6] text-chrome-text [text-wrap:pretty]">
      Upload a BOM and I'll find the suppliers, run the outreach and bring back
      quotes ready to award.
    </p>
  </div>
);

export default LoginPhoneIntro;
